module.exports = __webpack_public_path__ + "static/media/I.4aebd632.png";